/* unplugin-vue-components disabled */import script from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=07124204&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07124204"]])

export default __exports__